import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";
const buttonVariants = cva("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-[hsl(var(--primary-hover))]",
            destructive: "bg-destructive text-destructive-foreground hover:bg-red-700 dark:hover:bg-red-400",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground hover:bg-slate-200 dark:hover:bg-slate-700",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline",
        },
        size: {
            default: "h-10 px-4 py-2",
            sm: "h-9 rounded-md px-3",
            lg: "h-11 rounded-md px-8",
            icon: "h-10 w-10",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "sm", // CHANGED TO SM FOR TESTING
    },
});
const Button = React.forwardRef(({ className, variant, size = "sm", type = "button", ...props }, ref) => {
    return (_jsx("button", { type: type, className: cn(buttonVariants({ variant, size }), className), ref: ref, ...props }));
});
Button.displayName = "Button";
export { Button, buttonVariants };
export default Button;
//# sourceMappingURL=Button.js.map